<template>
  <div id="app">
    <transition>
      <keep-alive :include="allKeepAlive">
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
    <!-- {{ allKeepAlive }} -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Toast } from "vant";
export default {
  name: "App",
  data() {
    return {
      allKeepAlive: [],
    };
  },
  computed: {
    ...mapGetters(["getErrApi", "getErrBox", "getKeepArr"]),
  },

  watch: {
    getKeepArr: {
      immediate: true,
      handler: function () {
        // console.log(this.getKeepArr);
        this.allKeepAlive = this.getKeepArr;
      },
    },
    getErrApi: {
      deep: true, //深度监听设置为 true
      handler: function () {
        if (this.getErrApi.type == true) {
          Toast.fail(this.getErrApi.text);
          this.$store.commit("setErrApi", {
            type: false,
          });
        }
      },
    },
  },
  created() {
    window.goBack = this.goBack;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/style.scss";
//重置了一些样式
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  &::after,
  &::before {
    box-sizing: border-box;
    -moz-box-sizing: border-box; /* Firefox */
    -webkit-box-sizing: border-box; /* Safari */
  }
}
body {
  #app {
    font-size: 14px;
    font-family: "微软雅黑";
  }
  img {
    max-width: 100% !important;
    height: auto !important;
  }
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.van-cell {
  background: #f8f8f8;
  border: 1px solid #f8f8f8;
}
.van-cell.van-field {
  overflow: unset;
  .van-field__error-message {
    position: absolute;
    bottom: -32px;
    margin-left: -11px;
  }
}
.van-field--error.van-field {
  border: 1px solid #ff0000;
  background-color: #fff5f5;
}
</style>
